import { render } from "./client-registe-info-modal.vue?vue&type=template&id=4177faeb&scoped=true&ts=true"
import script from "./client-registe-info-modal.vue?vue&type=script&lang=ts"
export * from "./client-registe-info-modal.vue?vue&type=script&lang=ts"

import "./client-registe-info-modal.vue?vue&type=style&index=0&id=4177faeb&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4177faeb"]])

export default __exports__